import React from 'react';
import { Link } from 'react-router-dom';

const steps = [
  { num: 1, title: 'Talk to Us', desc: 'Share your repo, stack, and vision' },
  { num: 2, title: 'We Set It Up', desc: 'Environments, builds, and infra tailored to you' },
  { num: 3, title: 'You Ship', desc: 'Go live with full support and monitoring' },
];

const ProcessSnapshot = () => (
  <div className="bg-gray-100 py-16">
    <h2 className="text-3xl font-bold text-center text-blue-900 mb-8">Here’s How You Launch With Us</h2>
    <div className="max-w-4xl mx-auto grid gap-8 sm:grid-cols-1 md:grid-cols-3 px-8">
      {steps.map((s) => (
        <div key={s.num} className="bg-white shadow-lg rounded-lg p-6 text-center">
          <div className="text-3xl font-bold text-blue-900 mb-2">{s.num}</div>
          <h3 className="font-semibold text-xl mb-2">{s.title}</h3>
          <p className="text-gray-700 text-sm">{s.desc}</p>
        </div>
      ))}
    </div>
    <div className="flex justify-center mt-8 space-x-4">
      <Link to="/process" className="text-white bg-blue-900 hover:bg-blue-800 px-6 py-3 rounded-lg shadow">See the Full Process</Link>
      <Link
        to="/test-deployment"
        className="text-gray-500 border border-gray-400 hover:text-gray-700 hover:border-gray-400 px-6 py-3 rounded-lg shadow"
        onMouseEnter={(e) => (e.currentTarget.textContent = 'Coming soon')}
        onMouseLeave={(e) => (e.currentTarget.textContent = 'Try a Test Deployment')}
      >
        Try a Test Deployment
      </Link>
    </div>
  </div>
);

export default ProcessSnapshot;
